import { http, HttpResponse } from "msw";
import { getState, updateState } from "../state";

export const peopleHandlers = [
  http.get("/api/v1/people/list", () => {
    const state = getState();
    return HttpResponse.json({
      callsign_list: state.users.map((u) => ({
        callsign: u.callsign,
        roles: u.roles,
        extre: u.extre,
      })),
    });
  }),

  http.delete("/api/v1/people/:callsign", ({ params }) => {
    const { callsign } = params;
    const state = getState();
    const newUsers = state.users.filter((u) => u.callsign !== callsign);
    const newEnrollments = state.enrollments.filter(
      (e) => e.callsign !== callsign,
    );
    updateState({ users: newUsers, enrollments: newEnrollments });
    return HttpResponse.json({ invite_code: "mock-released-code" });
  }),

  http.get("/api/v1/enduserpfx/:callsign", () => {
    const fakeContent = new Uint8Array([0x00]);
    return new HttpResponse(fakeContent, {
      headers: {
        "Content-Type": "application/x-pkcs12",
        "Content-Disposition": "attachment; filename=mock-cert.pfx",
      },
    });
  }),

  http.get("/api/v1/instructions/user", () => {
    return HttpResponse.json({
      files: {
        tak: [
          {
            title: "ATAK Data Package",
            filename: "mock-atak-package.zip",
            data: "data:application/zip;base64,UEsFBgAAAAAAAAAAAAAAAAAAAAAAAA==",
          },
          {
            title: "iTAK Data Package",
            filename: "mock-itak-package.zip",
            data: "data:application/zip;base64,UEsFBgAAAAAAAAAAAAAAAAAAAAAAAA==",
          },
          {
            title: "Tracker Package",
            filename: "mock-tracker-package.zip",
            data: "data:application/zip;base64,UEsFBgAAAAAAAAAAAAAAAAAAAAAAAA==",
          },
        ],
      },
    });
  }),
];
